import { render, staticRenderFns } from "./lohn_detail.vue?vue&type=template&id=9ba123c4&scoped=true&"
import script from "./lohn_detail.vue?vue&type=script&lang=js&"
export * from "./lohn_detail.vue?vue&type=script&lang=js&"
import style0 from "./lohn_detail.vue?vue&type=style&index=0&id=9ba123c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba123c4",
  null
  
)

export default component.exports